import React, { useEffect, useRef } from 'react';
import '../css/Main.css';
import { useLocation, useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay, Keyboard, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { isMobile } from 'react-device-detect';

import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS 스타일시트 import

function Main({ content }) {
  // 이메일 폼 ref
  const agreeCheck = useRef(null);
  const companyName = useRef(null);
  const userName = useRef(null);
  const emailName = useRef(null);
  const phoneNumber = useRef(null);
  const title = useRef(null);
  const message = useRef(null);

  // 언어 감지 (content 객체의 특정 키로 판단)
  const isEnglish = content.footerCompany === "Spatial Core Inc.";

  // 날짜 형식 변환 함수 (영어일 때 영문식으로 변환)
  const formatDate = (dateStr) => {
    if (!isEnglish) return dateStr; // 한국어는 그대로 반환
    
    const [year, month] = dateStr.split('.');
    const monthNames = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
    const monthIndex = parseInt(month) - 1;
    return `${monthNames[monthIndex]} ${year}`;
  };

  // useLocation 훅을 사용하여 현재 URL 정보를 가져옵니다.
  const location = useLocation();
  const navigate = useNavigate();

  // ▼▼▼ 캔버스 애니메이션 로직을 useEffect 안에 넣습니다. ▼▼▼
  useEffect(() => {
    const cnvs = document.getElementById("hero-canvas");
    const heroSection = document.querySelector(".hero-section");
    if (!cnvs || !heroSection) return; // 캔버스나 hero-section이 없으면 실행 중지

    const c = cnvs.getContext('2d');
    
    // 부모 요소(.hero-section)의 크기에 맞게 캔버스 크기를 설정합니다.
    const setCanvasSize = () => {
      cnvs.width = cnvs.parentElement.offsetWidth;
      cnvs.height = cnvs.parentElement.offsetHeight;
    };
    
    setCanvasSize(); // 최초 1회 실행

    // 모바일에서는 점 개수 줄이기 (성능 최적화)
    var dots_num = isMobile ? 100 : 200;
    var r = 1;
    var mx = -1000, my = -1000; // 초기값을 화면 밖으로 설정
    var mouse_ol = 150;
    var mouse_ol_sq = mouse_ol * mouse_ol; // 제곱 거리 (Math.sqrt 제거)
    var dots_ol = 150;
    var dots_ol_sq = dots_ol * dots_ol; // 제곱 거리
    var max_speed = 0.5;
    var max_ms_opac = 1;
    var max_dots_opac = 0.5;
    var uni_divs = 10;

    // 마우스 위치는 hero-section 전체에서 감지하고 canvas 내부 좌표로 변환합니다.
    // 쓰로틀링으로 성능 최적화
    let mouseUpdateTimeout;
    const updtMouse = (e) => {
      if (mouseUpdateTimeout) return; // 이미 예약된 업데이트가 있으면 스킵
      mouseUpdateTimeout = requestAnimationFrame(() => {
        const rect = cnvs.getBoundingClientRect();
        // hero-section 내부에서 마우스 위치를 canvas 좌표로 변환
        mx = e.clientX - rect.left;
        my = e.clientY - rect.top;
        mouseUpdateTimeout = null;
      });
    };
    
    // hero-section 전체에 마우스 이벤트 추가 (hero-content 위에서도 작동하도록)
    const handleMouseLeave = () => {
      // hero-section을 벗어나면 마우스 위치를 화면 밖으로 설정
      mx = -1000;
      my = -1000;
    };
    
    heroSection.addEventListener('mousemove', updtMouse);
    heroSection.addEventListener('mouseleave', handleMouseLeave);

    var dots = [];

    var Dot = function(x, y, dx, dy) {
      this.x = x; this.y = y; this.dx = dx; this.dy = dy;
    }

    function init() {
      dots = []; // 배열 초기화
      for(let i=0; i<dots_num; i++) {
        let x = Math.floor((Math.random()*cnvs.width/uni_divs)+(parseInt(i/(dots_num/uni_divs))*(cnvs.width/uni_divs)));
        let y = Math.floor(Math.random()*cnvs.height);
        let dx = Math.random()*max_speed+0.1;
        let dy = Math.random()*max_speed+0.1;
        if(i%2==0) { dx*=-1; dy*=-1; }
        let temp = new Dot(x, y, dx, dy);
        dots.push(temp);
      }
    }

    let animationFrameId; // requestAnimationFrame ID를 저장할 변수

    function update() {
      c.clearRect(0, 0, cnvs.width, cnvs.height);

      for(let i=0; i<dots_num; i++) {
        let dy = dots[i].dy;
        let dx = dots[i].dx;

        dots[i].x += dx;
        dots[i].y += dy;

        // rebounce form walls
        if(dots[i].x>cnvs.width || dots[i].x<0) { dots[i].dx *= -1; }
        if(dots[i].y>cnvs.height || dots[i].y<0) { dots[i].dy *= -1; }

        let x = dots[i].x;
        let y = dots[i].y;

        // draw its line to mouse - 제곱 거리 사용 (Math.sqrt 제거)
        let dx_m = x - mx;
        let dy_m = y - my;
        let d_sq = dx_m * dx_m + dy_m * dy_m;
        if(d_sq < mouse_ol_sq) {
          let d = Math.sqrt(d_sq); // 실제로 선을 그릴 때만 sqrt 계산
          c.strokeStyle = `rgba(100, 238, 237, ${max_ms_opac*(mouse_ol-d)/mouse_ol})`;
          c.lineWidth = 2;
          c.beginPath();
          c.moveTo(x, y);
          c.lineTo(mx, my);
          c.stroke();
        }

        // draw lines with other dots - 제곱 거리 사용
        for(let j=i+1; j<dots_num; j++) {
          let x1 = dots[j].x;
          let y1 = dots[j].y;
          let dx_d = x1 - x;
          let dy_d = y1 - y;
          let d_sq = dx_d * dx_d + dy_d * dy_d;
          if(d_sq < dots_ol_sq) {
            let d = Math.sqrt(d_sq); // 실제로 선을 그릴 때만 sqrt 계산
            c.strokeStyle = `rgba(100, 238, 237, ${max_dots_opac*(dots_ol-d)/dots_ol})`;
            c.lineWidth = 1;
            c.beginPath();
            c.moveTo(x1, y1);
            c.lineTo(x, y);
            c.stroke();
          }
        }
      }
      animationFrameId = requestAnimationFrame(update);
    }

    init();
    update();

    // 화면 크기가 변경될 때 캔버스 크기를 다시 설정하고 애니메이션을 다시 시작합니다.
    // 디바운싱으로 성능 최적화
    let resizeTimeout;
    const handleResize = () => {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setCanvasSize();
        init(); // 점들을 새 크기에 맞게 다시 초기화
      }, 10); // 150ms 디바운스
    };
    
    window.addEventListener('resize', handleResize);

    // 컴포넌트가 언마운트될 때 이벤트 리스너와 애니메이션을 정리합니다.
    return () => {
      if (heroSection) {
        heroSection.removeEventListener('mousemove', updtMouse);
        heroSection.removeEventListener('mouseleave', handleMouseLeave);
      }
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(animationFrameId);
      if (resizeTimeout) clearTimeout(resizeTimeout);
      if (mouseUpdateTimeout) cancelAnimationFrame(mouseUpdateTimeout);
    };

  }, []); // [] 빈 배열은 이 훅이 컴포넌트 마운트 시 한 번만 실행되도록 합니다.
  // ▲▲▲ 캔버스 애니메이션 로직 끝 ▲▲▲

  // 이메일 보내기 함수
  const sendMail = (e) => {
    e.preventDefault(); // 폼 기본 제출 동작 방지

    const fields = [
      { 
        ref: agreeCheck, 
        message: '약관에 동의해주세요', 
        check: () => !agreeCheck.current?.checked // 체크 여부 확인
      },
      { 
        ref: companyName, 
        message: '회사명을 입력해주세요', 
        check: () => !companyName.current?.value || companyName.current.value === '' 
      },
      { 
        ref: userName, 
        message: '이름을 입력해주세요', 
        check: () => !userName.current?.value || userName.current.value === '' 
      },
      { 
        ref: emailName, 
        message: '이메일을 입력해주세요', 
        check: () => !emailName.current?.value || emailName.current.value === '' 
      },
    ];
    
    // 각 필드 체크
    for (const field of fields) {
      if (field.check()) {
        alert(field.message);
        field.ref.current?.focus(); // focus가 가능한 경우에만 호출
        return;
      }
    }

    // 필드들이 유효하면 이메일 보내기
    const userNameValue = userName.current.value;
    const emailValue = emailName.current.value;
    const companyValue = companyName.current.value;
    const titleValue = title.current?.value || '';
    const detailValue = message.current?.value || '';
    const numberValue = phoneNumber.current?.value || '';

    const templateParams = {
      userName: userNameValue,
      email: emailValue,
      companyName: companyValue,
      title: titleValue,
      detail: detailValue,
      number: numberValue,
    };

    emailjs
      .send('service_zo101yh', 'template_m5uoru7', templateParams, 'HJzLDFQZ4bLWUeM2k')
      .then(
        () => {
          alert('메시지가 성공적으로 전송되었습니다!');
          // 폼 초기화
          if (companyName.current) companyName.current.value = '';
          if (userName.current) userName.current.value = '';
          if (emailName.current) emailName.current.value = '';
          if (phoneNumber.current) phoneNumber.current.value = '';
          if (title.current) title.current.value = '';
          if (message.current) message.current.value = '';
          if (agreeCheck.current) agreeCheck.current.checked = false;
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('메시지 전송에 실패했습니다. 다시 시도해주세요.');
        }
      );
  };

  // ▼▼▼ 스크롤 로직 추가 ▼▼▼
  useEffect(() => {
    // URL의 쿼리 스트링(예: ?connect=true)을 쉽게 다룰 수 있게 해줍니다.
    const params = new URLSearchParams(location.search);
    
    // 만약 URL에 'connect'라는 파라미터가 'true' 값으로 존재한다면
    if (params.get('connect') === 'true') {
      // 1단계에서 지정한 id를 가진 요소를 찾습니다.
      const contactSection = document.getElementById('contact-us-section');
      
      // 만약 요소를 찾았다면,
      if (contactSection) {
        // 그 요소가 보이는 위치로 부드럽게 스크롤합니다.
        contactSection.scrollIntoView({ behavior: 'smooth' });

        // 스크롤을 실행한 후, URL에서 ?connect=true 부분을 제거합니다.
        // { replace: true } 옵션은 브라우저 히스토리에 남기지 않고 주소를 교체합니다.
        navigate(location.pathname, { replace: true });
      }
    }
  }, [location, navigate]); // location(주소)이 바뀔 때마다 이 코드를 다시 실행합니다.
  // ▲▲▲ 스크롤 로직 끝 ▲▲▲

  // ▼▼▼ 페이지가 처음 로드될 때 AOS를 실행시킵니다 ▼▼▼
  useEffect(() => {
    // AOS가 이미 초기화되었는지 확인 (중복 초기화 방지)
    // AOS는 body에 'aos-init' 클래스를 추가하거나 AOS.refresh()를 호출할 수 있음
    if (!window.AOS || !document.body.classList.contains('aos-init')) {
      AOS.init({
        duration: 1000, // 1초 동안 애니메이션
        once: true,     // 애니메이션은 한 번만 실행
      });
    } else {
      // 이미 초기화된 경우 새 요소만 애니메이션 적용
      AOS.refresh();
    }
  }, []);

  return (
    <main>
      {/* 1. 히어로 섹션 (기존 코드 유지) */}
      <section className="hero-section">

        <canvas id="hero-canvas"></canvas>

        <div className="hero-content">
          {/* 2. 하드코딩된 한글 대신 content 객체를 사용합니다. */}
          <h1 className="hero-title">{content.heroTitle}</h1>
          <p className="hero-subtitle">{content.heroSubtitle}</p>
        </div>
      </section>

      <div className='gradient-back'>
        {/* 2. Mission · Vision 섹션 */}
        <section className="section-container mission-vision-section" data-aos="fade-up">
          <h2 className="section-title">{content.missionTitle}</h2>
          <p className="section-subtitle">{content.missionSubtitle}</p>
        </section>
  
        {/* 3. Future Direction 섹션 */}
        <section className="section-container">
          <h2 className="section-title">{content.futureTitle}</h2>
          <div className="section3-container">
            <div className="section3-cards">
              <div className="section3-card card" data-aos="fade-up" data-aos-delay="100">
                <h3 className="card3-title-small">Autonomous Spatial Systems</h3>
                <p className="card3-content">{content.futureCard1}</p>
              </div>
              <div className="section3-card card" data-aos="fade-up" data-aos-delay="200">
                <h3 className="card3-title-small">Semantic Spatial Data Intelligence</h3>
                <p className="card3-content">{content.futureCard2}</p>
              </div>
            </div>
            <div className="section3-cards">
              <div className="section3-card card" data-aos="fade-up" data-aos-delay="300">
                <h3 className="card3-title-small">Human-Centric Spatial AI</h3>
                <p className="card3-content">{content.futureCard3}</p>
              </div>
              <div className="section3-card card" data-aos="fade-up" data-aos-delay="400">
                <h3 className="card3-title-small">Responsible Spatial Intelligence</h3>
                <p className="card3-content">{content.futureCard4}</p>
              </div>
            </div>
          </div>
        </section>
  
        {/* --- 4. 프로토타입 섹션 (Swiper) --- */}
        <section className="section-container prototype-section" data-aos="fade-up">
          <h2 className="section-title">{content.protoTitle}</h2>
          <p className="section-subtitle">{content.protoSubtitle}</p>
  
          <Swiper
            className="proto-swiper"
            modules={[EffectCoverflow, Autoplay, Keyboard, Mousewheel]}
            effect="coverflow"
            centeredSlides
            slidesPerView="auto"
            spaceBetween={24}
            loop
            watchSlidesProgress
            roundLengths
            grabCursor
            keyboard={{ enabled: true }}
            mousewheel={{ thresholdDelta: 70 }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 140,
              modifier: 2.6,
              slideShadows: false
            }}
            onSwiper={(s) => {
              s.slideToLoop(1, 0);
              s.autoplay.start(); /* (추가) Swiper 로드 시 자동재생 즉시 시작 */
            }}
          >
            <SwiperSlide className="proto-slide">
              <div className="proto-card proto-1">
                <iframe 
                  src="/prototypes/geospatial.html"
                  title="Geospatial POI Data Integration Platform"
                  loading="lazy" />
              </div>
            </SwiperSlide>
            <SwiperSlide className="proto-slide">
              <div className="proto-card proto-2">
                <iframe
                  src="/prototypes/unified.html"
                  title="Autonomous Systems Command Center"
                  loading="lazy" />
              </div>
            </SwiperSlide>
            <SwiperSlide className="proto-slide">
              <div className="proto-card proto-3">
                <iframe 
                  src="/prototypes/dqms.html"
                  title="Data Quality Management System"
                  loading="lazy" />
              </div>
            </SwiperSlide>
            <SwiperSlide className="proto-slide">
              <div className="proto-card proto-4">
                <iframe 
                  src="/prototypes/geospatial.html"
                  title="Geospatial POI Data Integration Platform"
                  loading="lazy" />
              </div>
            </SwiperSlide>
            <SwiperSlide className="proto-slide">
              <div className="proto-card proto-5">
                <iframe 
                  src="/prototypes/unified.html"
                  title="Autonomous Systems Command Center"
                  loading="lazy" />
              </div>
            </SwiperSlide>
            <SwiperSlide className="proto-slide">
              <div className="proto-card proto-6">
                <iframe 
                  src="/prototypes/dqms.html"
                  title="Data Quality Management System"
                  loading="lazy" />
              </div>
            </SwiperSlide>
  
          </Swiper>
        </section>
  
        {/* 5. Core Business Areas 섹션 */}
        <section className="section-container" data-aos="fade-up">
          <h2 className="section-title">{content.coreTitle}</h2>
          <div className="grid-container" data-aos="fade-up">
            <div className="flex-cards" data-aos="fade-up" data-aos-delay="100">
              <div className="card5">
                <h3 className="card5-title-small"><span className="tetxtcolor">Spatial AI</span> {content.coreCard1Title}</h3>
                <p className="card5-content">{content.coreCard1Content}</p>
              </div>
              <div className="card5">
                <h3 className="card5-title-small"><span className="tetxtcolor">Spatial AI</span> {content.coreCard2Title}</h3>
                <p className="card5-content">{content.coreCard2Content}</p>
              </div>
            </div>
            <div className="flex-cards" data-aos="fade-up" data-aos-delay="200">
              <div className="card5">
                <h3 className="card5-title-small"><span className="tetxtcolor">Spatial AI</span> {content.coreCard3Title}</h3>
                <p className="card5-content">{content.coreCard3Content}</p>
              </div>
              <div className="card5">
                <h3 className="card5-title-small"><span className="tetxtcolor">Spatial AI</span> {content.coreCard4Title}</h3>
                <p className="card5-content">{content.coreCard4Content}</p>
              </div>
              <div className="card5">
                <h3 className="card5-title-small"><span className="tetxtcolor">Spatial AI</span> {content.coreCard5Title}</h3>
                <p className="card5-content">{content.coreCard5Content}</p>
              </div>
            </div>
            <div className="flex-cards" data-aos="fade-up" data-aos-delay="300">
              <div className="card5">
                <h3 className="card5-title-small"><span className="tetxtcolor">Spatial AI</span> {content.coreCard6Title}</h3>
                <p className="card5-content">{content.coreCard6Content}</p>
              </div>
              <div className="card5">
                <h3 className="card5-title-small"><span className="tetxtcolor">Spatial AI</span> {content.coreCard7Title}</h3>
                <p className="card5-content">{content.coreCard7Content}</p>
              </div>
            </div>
          </div>
        </section>
  
        {/* 6. History 섹션 */}
        <section className="section-container" data-aos="fade-up">
          <h2 className="section-title">{content.historyTitle}</h2>
          <div className="timeline-container">
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2026.01")}</p>
                <p className="timeline-desc">{content.historyDesc16}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2025.12")}</p>
                <p className="timeline-desc">{content.historyDesc15}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2025.10")}</p>
                <p className="timeline-desc">{content.historyDesc14}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2025.09")}</p>
                <p className="timeline-desc">{content.historyDesc13}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2025.04")}</p>
                <p className="timeline-desc">{content.historyDesc12}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2024.11")}</p>
                <p className="timeline-desc">{content.historyDesc11}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2024.09")}</p>
                <p className="timeline-desc">{content.historyDesc10}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2024.09")}</p>
                <p className="timeline-desc">{content.historyDesc9}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2024.05")}</p>
                <p className="timeline-desc">{content.historyDesc8}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2024.01")}</p>
                <p className="timeline-desc">{content.historyDesc7}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2023.11")}</p>
                <p className="timeline-desc">{content.historyDesc6}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2023.10")}</p>
                <p className="timeline-desc">{content.historyDesc4}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2023.07")}</p>
                <p className="timeline-desc">{content.historyDesc3}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2023.06")}</p>
                <p className="timeline-desc">{content.historyDesc5}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-right">
              <div className="timeline-content left">
                <p className="timeline-date">{formatDate("2021.01")}</p>
                <p className="timeline-desc">{content.historyDesc2}</p>
              </div>
            </div>
            <div className="timeline-item" data-aos="fade-left">
              <div className="timeline-content right">
                <p className="timeline-date">{formatDate("2020.11")}</p>
                <p className="timeline-desc">{content.historyDesc1}</p>
              </div>
            </div>
          </div>
        </section>
  
        {/* 7. ESG 섹션 */}
        <section className="section-container esg-section" data-aos="fade-up">
          <h2 className="section-title">{content.esgTitle}</h2>
          <p className="section-subtitle">{content.esgSubtitle}</p>
          <p className="section-subtitle-7">{content.esgSubtitle}</p>
          <div className="grid-container grid-1x3">
            <div className="card7" data-aos="fade-up" data-aos-delay="100">
              <h3 className="card7-title-small">{content.esgCard1Title}</h3>
              <p className="card7-content">{content.esgCard1Content}</p>
            </div>
            <div className="card7" data-aos="fade-up" data-aos-delay="200">
              <h3 className="card7-title-small">{content.esgCard2Title}</h3>
              <p className="card7-content">{content.esgCard2Content}</p>
            </div>
            <div className="card7" data-aos="fade-up" data-aos-delay="300">
              <h3 className="card7-title-small">{content.esgCard3Title}</h3>
              <p className="card7-content">{content.esgCard3Content}</p>
            </div>
          </div>
        </section>
  
        {/* 8. Contact us 섹션 */}
        <section id="contact-us-section" className="section-container contact-section" data-aos="fade-up">
          <div className="contact-content">
            <div className="contact-text">
              <h2 className="section-title left-align">{content.contactTitle}</h2>
              <p>{content.contactSubtitle}</p>
            </div>
            <form className="contact-form" onSubmit={sendMail}>
              <input 
                type="text" 
                placeholder={content.contactFormName || "이름"} 
                ref={userName}
                required
              />
              <input 
                type="email" 
                placeholder={content.contactFormEmail || "이메일"} 
                ref={emailName}
                required
              />
              <input 
                type="text" 
                placeholder={content.contactFormCompany || "회사명"} 
                ref={companyName}
                required
              />
              <input 
                type="text" 
                placeholder={content.contactFormPhone || "전화번호 (선택)"} 
                ref={phoneNumber}
              />
              <input 
                type="text" 
                placeholder={content.contactFormTitle || "제목 (선택)"} 
                ref={title}
              />
              <textarea 
                placeholder={content.contactFormMessage || "문의 내용"} 
                ref={message}
              ></textarea>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <input 
                  type="checkbox" 
                  ref={agreeCheck}
                  required
                  style={{ marginRight: '8px' }}
                />
                <label style={{ fontSize: '14px', color: '#666' }}>
                  {content.contactFormAgree || "개인정보 수집 및 이용 동의"} <span style={{ color: '#ff0000' }}>*</span>
                </label>
              </div>
              <button type="submit">{content.contactFormButton || "문의하기"}</button>
            </form>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Main;